@file:OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class, ExperimentalLayoutApi::class)

package com.example.monetix.ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.tween
import androidx.compose.ui.draw.blur
import kotlinx.coroutines.delay
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.basicMarquee
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.gestures.snapping.rememberSnapFlingBehavior
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material.icons.outlined.CheckCircle
import androidx.compose.material.icons.outlined.Visibility
import androidx.compose.material.icons.outlined.VisibilityOff
import androidx.compose.material.icons.rounded.Calculate
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material.icons.outlined.Edit
import androidx.compose.material.icons.outlined.Restore
import androidx.compose.material.icons.outlined.VisibilityOff
import androidx.compose.material.icons.rounded.AutoFixHigh
import androidx.compose.material.icons.rounded.CheckCircle
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.window.PopupProperties
import androidx.compose.ui.zIndex
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback

// Import KMP
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import app.cash.sqldelight.async.coroutines.awaitAsList
import coil3.compose.AsyncImage

// Import Database SQLDelight
import com.example.monetix.db.MonetixDatabase
import com.example.monetix.db.AccountEntity
import com.example.monetix.db.CategoryEntity
import com.example.monetix.db.FinancingEntity
import com.example.monetix.db.TransactionEntity

// Altri import
import com.example.monetix.utils.formatEuroFromCents
import com.example.monetix.stripSystemMarker
import com.example.monetix.utils.parseDayMonthYearToEpochDayOrNull
import com.example.monetix.ui.components.TxLogo
import com.example.monetix.HomeViewModel
import com.example.monetix.ui.components.ModernMoneyText
import com.example.monetix.ui.components.MonetixGlassSwitch
import com.example.monetix.ui.dialogs.LoanSimulatorDialog
import com.example.monetix.utils.AutomationEngine
import com.example.monetix.utils.autoFaviconUrlForName
import com.example.monetix.utils.rememberMediaHandler
import kotlin.math.roundToLong
import kotlin.math.roundToInt


// ==========================================
// 🚀 MOTORE SEMANTICO PER FINANZIARIE
// ==========================================
private data class FinancingPredefCreditor(
    val name: String,
    val domain: String? = null,
    val customUrl: String? = null,
    val customEmoji: String? = null
) {
    val url get() = customUrl ?: domain?.let { "https://icon.horse/icon/$it" }
}

private val defaultCreditorSuggestions = listOf(
    FinancingPredefCreditor("Findomestic", "findomestic.it"),
    FinancingPredefCreditor("Compass", "compass.it"),
    FinancingPredefCreditor("Agos", "agos.it"),
    FinancingPredefCreditor("Younited Credit", "younited-credit.com"),
    FinancingPredefCreditor("Cofidis", "cofidis.it"),
    FinancingPredefCreditor("Santander", "santanderconsumer.it"),
    FinancingPredefCreditor("Fiditalia", "fiditalia.it"),
    FinancingPredefCreditor("Prestipay", "prestipay.it"),
    FinancingPredefCreditor("CA Auto Bank", "ca-autobank.it"),
    FinancingPredefCreditor("Sella Personal Credit", "sellapersonalcredit.it"),
    FinancingPredefCreditor("Intesa Sanpaolo", "intesasanpaolo.com"),
    FinancingPredefCreditor("UniCredit", "unicredit.it"),
    FinancingPredefCreditor("BNL", "bnl.it"),
    FinancingPredefCreditor("Poste Italiane", "poste.it"),
    FinancingPredefCreditor("PayPal", "paypal.com", "https://logo.clearbit.com/paypal.com"),
    FinancingPredefCreditor("Klarna", "klarna.com", "https://logo.clearbit.com/klarna.com"),
    FinancingPredefCreditor("Scalapay", "scalapay.com"),
    FinancingPredefCreditor("Clearpay", "clearpay.com"),
    FinancingPredefCreditor("Volkswagen Financial Services", "vwfs.it")
)

private fun detectSmartCreditor(input: String): FinancingPredefCreditor? {
    val clean = input.trim().lowercase()
    if (clean.length < 3) return null
    return defaultCreditorSuggestions.firstOrNull { it.name.lowercase().contains(clean) }
}

// ==========================================
// 🚀 COMPONENTI ISOLATI E PRIVATI
// ==========================================
@Composable
private fun StableWebTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String = "",
    placeholder: String = "",
    modifier: Modifier = Modifier,
    trailingIcon: @Composable (() -> Unit)? = null,
    leadingIcon: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    keyboardType: KeyboardType = KeyboardType.Text,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    minLines: Int = 1
) {
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        label = if (label.isNotBlank()) { { Text(label, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) } } else null,
        placeholder = if (placeholder.isNotBlank()) { { Text(placeholder, color = Color(0xFFA0A0A0).copy(alpha = 0.5f)) } } else null,
        minLines = minLines,
        maxLines = if (minLines == 1) 1 else Int.MAX_VALUE,
        enabled = enabled,
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(12.dp),
        trailingIcon = trailingIcon,
        leadingIcon = leadingIcon,
        interactionSource = interactionSource,
        textStyle = LocalTextStyle.current.copy(color = Color.White),
        colors = OutlinedTextFieldDefaults.colors(
            focusedTextColor = Color.White,
            unfocusedTextColor = Color.White,
            disabledTextColor = Color.White.copy(alpha = 0.7f),
            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
            disabledContainerColor = Color.Black.copy(alpha = 0.15f),
            focusedBorderColor = Color(0xFF60A5FA),
            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
            disabledBorderColor = Color.White.copy(alpha = 0.10f),
            focusedLabelColor = Color(0xFF60A5FA),
            unfocusedLabelColor = Color(0xFFA0A0A0),
            disabledLabelColor = Color(0xFFA0A0A0).copy(alpha = 0.5f),
            cursorColor = Color.White
        ),
        keyboardOptions = KeyboardOptions(keyboardType = keyboardType, autoCorrectEnabled = false)
    )
}

// ==========================================
// FUNZIONI UTILITY GLOBALI & MATEMATICA SICURA
// ==========================================
fun lengthOfMonthKmp(year: Int, month: Int): Int {
    val isLeap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0))
    return when (month) {
        2 -> if (isLeap) 29 else 28
        4, 6, 9, 11 -> 30
        else -> 31
    }
}

fun addMonths(date: LocalDate, monthsToAdd: Int, preferredDay: Int = date.dayOfMonth): LocalDate {
    var m = date.monthNumber + monthsToAdd
    var y = date.year
    while (m > 12) { m -= 12; y++ }
    val maxDays = lengthOfMonthKmp(y, m)
    return LocalDate(y, m, minOf(preferredDay, maxDays))
}

private fun formatKmpDate(date: LocalDate): String {
    val d = date.dayOfMonth.toString().padStart(2, '0')
    val m = date.monthNumber.toString().padStart(2, '0')
    val y = date.year.toString().padStart(4, '0')
    return "$d/$m/$y"
}

fun safeCalculateTotalInstallments(f: FinancingEntity): Int {
    val start = try { LocalDate.fromEpochDays(f.startEpochDay.toInt()) } catch(e: Throwable) { return 1 }
    val end = try { LocalDate.fromEpochDays(f.endEpochDay.toInt()) } catch(e: Throwable) { return 1 }
    val months = (end.year - start.year) * 12 + (end.monthNumber - start.monthNumber) + 1
    return months.coerceAtLeast(1)
}

fun safeCalculatePaidInstallments(f: FinancingEntity, today: LocalDate): Int {
    val start = try { LocalDate.fromEpochDays(f.startEpochDay.toInt()) } catch(e: Throwable) { return 0 }
    if (today < start) return 0
    var count = 0
    val preferredDay = f.smartDueDay
    var curr = start
    while (curr <= today) {
        count++
        curr = addMonths(start, count, preferredDay)
    }
    return count
}

enum class AmountTarget { NONE, INSTALLMENT, COMMISSION, EXTRA }

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun <T> WheelPicker(items: List<T>, initialValue: T, onValueChanged: (T) -> Unit, modifier: Modifier = Modifier, labelExtractor: (T) -> String = { it.toString() }) {
    val initialIndex = items.indexOf(initialValue).coerceAtLeast(0)
    val listState = rememberLazyListState(initialFirstVisibleItemIndex = initialIndex)
    val flingBehavior = rememberSnapFlingBehavior(lazyListState = listState)
    val itemHeight = 48.dp

    LaunchedEffect(listState.isScrollInProgress) {
        if (!listState.isScrollInProgress && listState.layoutInfo.visibleItemsInfo.isNotEmpty()) {
            val centerOffset = listState.layoutInfo.viewportEndOffset / 2
            val closestItem = listState.layoutInfo.visibleItemsInfo.minByOrNull { kotlin.math.abs(it.offset + (it.size / 2) - centerOffset) }
            if (closestItem != null) {
                val dataIndex = closestItem.index - 1
                if (dataIndex in items.indices) {
                    onValueChanged(items[dataIndex])
                    listState.animateScrollToItem(dataIndex)
                }
            }
        }
    }

    Box(modifier = modifier.height(itemHeight * 3), contentAlignment = Alignment.Center) {
        LazyColumn(state = listState, flingBehavior = flingBehavior, horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.fillMaxSize()) {
            item { Spacer(modifier = Modifier.height(itemHeight)) }
            items(items.size) { index ->
                Box(modifier = Modifier.height(itemHeight).fillMaxWidth(), contentAlignment = Alignment.Center) {
                    Text(text = labelExtractor(items[index]), style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold, fontSize = 24.sp), color = Color.White)
                }
            }
            item { Spacer(modifier = Modifier.height(itemHeight)) }
        }
        HorizontalDivider(modifier = Modifier.align(Alignment.TopCenter).padding(top = itemHeight), color = MaterialTheme.colorScheme.primary, thickness = 2.dp)
        HorizontalDivider(modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = itemHeight), color = MaterialTheme.colorScheme.primary, thickness = 2.dp)
    }
}

// ==========================================
// 🚀 POPUP RICERCA IMMAGINI WEB AUTOMATICA
// ==========================================
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WebImagePickerPopup(
    initialQuery: String,
    onDismiss: () -> Unit,
    onImageSelected: (String) -> Unit
) {
    var query by remember { mutableStateOf(initialQuery) }
    var results by remember { mutableStateOf<List<String>>(emptyList()) }
    val uriHandler = LocalUriHandler.current

    fun generateLinks(qRaw: String) {
        val q = qRaw.trim().lowercase().replace(" ", "")
        if (q.isEmpty()) {
            results = emptyList()
            return
        }
        results = listOf(
            "https://logo.clearbit.com/$q.com",
            "https://logo.clearbit.com/$q.it",
            "https://icon.horse/icon/$q.com",
            "https://icon.horse/icon/$q.it",
            "https://icon.horse/icon/$q.net",
            "https://icon.horse/icon/$q.org",
            "https://www.google.com/s2/favicons?domain=$q.com&sz=128",
            "https://www.google.com/s2/favicons?domain=$q.it&sz=128"
        ).distinct()
    }

    LaunchedEffect(initialQuery) {
        if (initialQuery.isNotBlank()) generateLinks(initialQuery)
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = Color(0xFF27272A),
        title = { Text("Ricerca Logo Web", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                OutlinedTextField(
                    value = query,
                    onValueChange = { query = it },
                    label = { Text("Nome brand o azienda", color = Color(0xFFA0A0A0)) },
                    trailingIcon = {
                        IconButton(onClick = { generateLinks(query) }) {
                            Icon(Icons.Default.Search, contentDescription = "Cerca", tint = Color(0xFF60A5FA))
                        }
                    },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color(0xFF1C1C1E), unfocusedContainerColor = Color(0xFF1C1C1E), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.15f), focusedLabelColor = Color(0xFF60A5FA), unfocusedLabelColor = Color(0xFFA0A0A0))
                )

                if (results.isNotEmpty()) {
                    Text("Tocca il logo che preferisci:", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    LazyVerticalGrid(
                        columns = GridCells.Adaptive(60.dp),
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp),
                        modifier = Modifier.height(180.dp).fillMaxWidth()
                    ) {
                        items(results) { url ->
                            Box(
                                modifier = Modifier
                                    .aspectRatio(1f)
                                    .clip(RoundedCornerShape(12.dp))
                                    .background(Color.White.copy(alpha = 0.1f))
                                    .clickable { onImageSelected(url) }
                                    .border(1.dp, Color.White.copy(alpha = 0.2f), RoundedCornerShape(12.dp)),
                                contentAlignment = Alignment.Center
                            ) {
                                AsyncImage(
                                    model = url,
                                    contentDescription = null,
                                    modifier = Modifier.fillMaxSize().padding(8.dp)
                                )
                            }
                        }
                    }
                } else {
                    Box(modifier = Modifier.height(180.dp).fillMaxWidth(), contentAlignment = Alignment.Center) {
                        Text("Scrivi un brand e premi la lente", color = Color(0xFFA0A0A0))
                    }
                }

                HorizontalDivider(color = Color.White.copy(alpha = 0.1f))

                Button(
                    onClick = {
                        val q = if (query.isNotBlank()) "${query} logo icon" else "logo icon"
                        uriHandler.openUri("https://www.google.com/search?tbm=isch&q=${q.replace(" ", "+")}")
                    },
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF3F3F46), contentColor = Color.White)
                ) {
                    Icon(Icons.Default.Search, contentDescription = null, modifier = Modifier.size(18.dp), tint = Color.White)
                    Spacer(Modifier.width(8.dp))
                    Text("Non lo trovi? Cerca su Google", color = Color.White)
                }

                var manualUrl by remember { mutableStateOf("") }
                OutlinedTextField(
                    value = manualUrl,
                    onValueChange = { manualUrl = it },
                    label = { Text("Incolla URL immagine qui", fontSize = 10.sp, color = Color(0xFFA0A0A0)) },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp),
                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color(0xFF1C1C1E), unfocusedContainerColor = Color(0xFF1C1C1E), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.15f), focusedLabelColor = Color(0xFF60A5FA), unfocusedLabelColor = Color(0xFFA0A0A0))
                )

                AnimatedVisibility(visible = manualUrl.isNotBlank()) {
                    Column(
                        modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text("Anteprima Immagine:", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                        Spacer(Modifier.height(8.dp))
                        Box(
                            modifier = Modifier
                                .size(80.dp)
                                .clip(RoundedCornerShape(12.dp))
                                .background(Color.White.copy(alpha = 0.1f))
                                .border(1.dp, Color.White.copy(alpha = 0.2f), RoundedCornerShape(12.dp)),
                            contentAlignment = Alignment.Center
                        ) {
                            AsyncImage(
                                model = manualUrl,
                                contentDescription = "Anteprima URL",
                                modifier = Modifier.fillMaxSize().padding(8.dp)
                            )
                        }
                        Spacer(Modifier.height(12.dp))
                        Button(
                            onClick = { onImageSelected(manualUrl) },
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                        ) {
                            Text("Usa questa immagine", fontWeight = FontWeight.Bold, color = Color.White)
                        }
                    }
                }
            }
        },
        confirmButton = {
            TextButton(onClick = onDismiss) { Text("CHIUDI", color = Color(0xFFA0A0A0)) }
        }
    )
}

// ==========================================
// SCREEN PRINCIPALE
// ==========================================
@Composable
fun FinancingScreen(
    viewModel: HomeViewModel,
    db: MonetixDatabase,
    accounts: List<AccountEntity>,
    categories: List<CategoryEntity>,
    financings: List<FinancingEntity>,
    onChanged: () -> Unit,
    hideAmounts: Boolean = false,
    activeAccountId: String? = null,
    generateTick: Int = 0,
    createTick: Int = 0,
    onCreateTickConsumed: () -> Unit = {},
    onPopupStateChanged: (Boolean) -> Unit = {}
) {
    val safeScope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    val snackbarHostState = remember { SnackbarHostState() }

    val isCollapsed by remember { derivedStateOf { listState.firstVisibleItemIndex > 0 || listState.firstVisibleItemScrollOffset > 50 } }
    val haptic = LocalHapticFeedback.current

    var txs by remember { mutableStateOf<List<TransactionEntity>>(emptyList()) }
    var creating by remember { mutableStateOf(false) }
    var tabIndex by remember { mutableStateOf(0) }
    var generating by remember { mutableStateOf(false) }
    var editingFin by remember { mutableStateOf<FinancingEntity?>(null) }
    var hideFinancingAmounts by remember(hideAmounts) { mutableStateOf(hideAmounts) }
    var financingToDelete by remember { mutableStateOf<FinancingEntity?>(null) }
    var financingToToggleState by remember { mutableStateOf<FinancingEntity?>(null) }
    var detailsFinancing by remember { mutableStateOf<FinancingEntity?>(null) }
    var activeDetailsFinancing by remember { mutableStateOf<FinancingEntity?>(null) }

    var isHeaderExpanded by rememberSaveable { mutableStateOf(false) }
    var showGenerationFeedback by remember { mutableStateOf(false) }
    var showSimulator by remember { mutableStateOf(false) }

    suspend fun reloadTxs() {
        txs = try { db.transactionQueries.getAllTransactions().awaitAsList() } catch (_: Throwable) { emptyList() }
    }

    fun nextDueDateForFinancing(f: FinancingEntity, fromDate: LocalDate): LocalDate {
        val dueDay = f.smartDueDay
        val currentYear = fromDate.year
        val currentMonth = fromDate.monthNumber
        val currentMonthDueDay = dueDay.coerceIn(1, lengthOfMonthKmp(currentYear, currentMonth))
        val currentMonthDue = LocalDate(currentYear, currentMonth, currentMonthDueDay)
        if (currentMonthDue >= fromDate) return currentMonthDue
        var nextMonth = currentMonth + 1
        var nextYear = currentYear
        if (nextMonth > 12) { nextMonth = 1; nextYear++ }
        val nextMonthDueDay = dueDay.coerceIn(1, lengthOfMonthKmp(nextYear, nextMonth))
        return LocalDate(nextYear, nextMonth, nextMonthDueDay)
    }

    val triggerGeneration: () -> Unit = {
        safeScope.launch {
            if (generating) return@launch
            generating = true
            try {
                AutomationEngine.processPendingAutomations(db, viewModel.firestore)
                reloadTxs()
                onChanged()
                showGenerationFeedback = true
            } catch (t: Throwable) {
                snackbarHostState.showSnackbar("ERRORE DURANTE LA GENERAZIONE")
            } finally {
                generating = false
            }
        }
    }

    LaunchedEffect(Unit) { reloadTxs(); onChanged() }
    LaunchedEffect(generateTick) { if (generateTick != 0) triggerGeneration() }
    LaunchedEffect(createTick) { if (createTick != 0) { creating = true; onCreateTickConsumed() } }

    val shown = remember(financings, tabIndex) {
        val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
        financings.filter { !it.isDeleted && (if (tabIndex == 0) !it.isClosed else it.isClosed) }
            .sortedWith(if (tabIndex == 0) compareBy<FinancingEntity> { nextDueDateForFinancing(it, today) } else compareBy { it.name })
    }

    val activeFinancings = financings.filter { !it.isDeleted && !it.isClosed }
    val todayEpochDays = Clock.System.todayIn(TimeZone.currentSystemDefault()).toEpochDays().toLong()

    val totalRemainingCents = activeFinancings.sumOf { f ->
        val totalInst = safeCalculateTotalInstallments(f)
        val calendarPaid = safeCalculatePaidInstallments(f, Clock.System.todayIn(TimeZone.currentSystemDefault()))

        val earlyPaidTxs = txs.count {
            !it.isDeleted &&
                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                    it.dateEpochDay > todayEpochDays
        }

        val deletedCalendarTxs = txs.count {
            it.isDeleted &&
                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                    it.dateEpochDay <= todayEpochDays
        }

        val paidInst = (calendarPaid - deletedCalendarTxs + earlyPaidTxs).coerceIn(0, totalInst)

        val planned = f.installmentAmountCents * totalInst.toLong()
        val pagato = (f.installmentAmountCents * paidInst.toLong()).coerceAtMost(planned)
        (planned - pagato).coerceAtLeast(0L)
    }

    val brandPrimary = Color(0xFF60A5FA)

    var showDetailsSheet by rememberSaveable { mutableStateOf(false) }

    val totalPaidCents = remember(activeFinancings, txs, todayEpochDays) {
        activeFinancings.sumOf { f ->
            val totalInst = safeCalculateTotalInstallments(f)
            val calendarPaid = safeCalculatePaidInstallments(f, Clock.System.todayIn(TimeZone.currentSystemDefault()))
            val earlyPaidTxs = txs.count { !it.isDeleted && (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) && it.dateEpochDay > todayEpochDays }
            val deletedCalendarTxs = txs.count { it.isDeleted && (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) && it.dateEpochDay <= todayEpochDays }
            val paidInst = (calendarPaid - deletedCalendarTxs + earlyPaidTxs).coerceIn(0, totalInst)

            (f.installmentAmountCents * paidInst.toLong()).coerceAtMost(f.installmentAmountCents * totalInst.toLong())
        }
    }

    val isFinancingPopupOpen = showGenerationFeedback || showSimulator || creating || editingFin != null ||
            financingToDelete != null || financingToToggleState != null || detailsFinancing != null ||
            activeDetailsFinancing != null || showDetailsSheet

    LaunchedEffect(isFinancingPopupOpen) {
        onPopupStateChanged(isFinancingPopupOpen)
    }

    val financingBlur by animateDpAsState(
        targetValue = if (isFinancingPopupOpen) 12.dp else 0.dp,
        animationSpec = tween(durationMillis = 300),
        label = "financingBlur"
    )

    Scaffold(snackbarHost = { SnackbarHost(snackbarHostState) }, containerColor = Color.Transparent) { paddingValues ->
        val hasCustomBg = com.example.monetix.LocalHasCustomBackground.current

        Box(
            modifier = Modifier
                .fillMaxSize()
                .then(
                    if (hasCustomBg) Modifier.background(Color.Transparent)
                    else Modifier.background(
                        Brush.verticalGradient(
                            colors = listOf(
                                Color(0xFF701A75).copy(alpha = 0.6f),
                                Color(0xFF1E1B4B),
                                Color(0xFF0F172A)
                            )
                        )
                    )
                )
                .blur(financingBlur)
                .padding(paddingValues)
        ) {
            Column(modifier = Modifier.fillMaxSize()) {

                // ==========================================
                // 1. TOP BAR REVOLUT DARK
                // ==========================================
                Surface(modifier = Modifier.fillMaxWidth().zIndex(1f), color = Color.Transparent) {
                    Column(modifier = Modifier.statusBarsPadding().padding(start = 16.dp, end = 16.dp, top = 20.dp, bottom = 12.dp)) {

                        Row(modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp), verticalAlignment = Alignment.CenterVertically) {
                            Text("I tuoi debiti", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color.White)
                            Spacer(Modifier.weight(1f))
                            IconButton(
                                onClick = { hideFinancingAmounts = !hideFinancingAmounts },
                                modifier = Modifier.size(36.dp)
                            ) {
                                Icon(if (hideFinancingAmounts) Icons.Outlined.VisibilityOff else Icons.Outlined.Visibility, null, tint = Color.White)
                            }
                        }

                        // Debito Residuo Stampato a Schermo (Trasparente senza Card)
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable { showDetailsSheet = true }
                                .padding(horizontal = 4.dp, vertical = 8.dp)
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    text = "DEBITO RESIDUO",
                                    fontSize = 11.sp,
                                    fontWeight = FontWeight.ExtraBold,
                                    color = Color.White.copy(alpha = 0.7f),
                                    letterSpacing = 1.2.sp
                                )
                                Icon(
                                    imageVector = Icons.Default.ExpandMore,
                                    contentDescription = "Tocca per dettagli",
                                    tint = Color.White.copy(alpha = 0.5f),
                                    modifier = Modifier.size(20.dp)
                                )
                            }

                            Spacer(modifier = Modifier.height(6.dp))

                            ModernMoneyText(
                                cents = totalRemainingCents,
                                hideBalances = hideFinancingAmounts,
                                color = Color.White,
                                integerFontSize = 42.sp,
                                decimalFontSize = 24.sp,
                                symbolFontSize = 24.sp
                            )
                        }

                        Spacer(Modifier.height(16.dp))

                        // Filtro Stato Finanziamenti
                        Row(modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("STATO FINANZIAMENTI", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = Color(0xFFA0A0A0))
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                listOf("ATTIVI", "ESTINTI").forEachIndexed { index, title ->
                                    val sel = tabIndex == index
                                    Surface(
                                        onClick = { tabIndex = index },
                                        shape = RoundedCornerShape(20.dp),
                                        color = if (sel) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f),
                                        border = BorderStroke(1.dp, if (sel) Color.White.copy(alpha = 0.35f) else Color.White.copy(alpha = 0.12f))
                                    ) {
                                        Text(
                                            text = title,
                                            style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold),
                                            color = Color.White,
                                            modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

            // ==========================================
            // 2. LISTA RATE (SCORREVOLE)
            // ==========================================
            LazyColumn(state = listState, modifier = Modifier.weight(1f), contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp), verticalArrangement = Arrangement.Top) {
                if (shown.isEmpty()) {
                    item { Box(Modifier.fillMaxWidth().height(200.dp), contentAlignment = Alignment.Center) { Text("Nessun debito in archivio", style = MaterialTheme.typography.bodyLarge, color = Color(0xFFA0A0A0)) } }
                } else {
                    items(shown, key = { it.id }) { f ->
                        val totalInstallments = safeCalculateTotalInstallments(f)
                        val calendarPaid = safeCalculatePaidInstallments(f, Clock.System.todayIn(TimeZone.currentSystemDefault()))

                        val earlyPaidTxs = txs.count {
                            !it.isDeleted &&
                                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                                    it.dateEpochDay > todayEpochDays
                        }

                        val deletedCalendarTxs = txs.count {
                            it.isDeleted &&
                                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                                    it.dateEpochDay <= todayEpochDays
                        }

                        val paidInstallments = (calendarPaid - deletedCalendarTxs + earlyPaidTxs).coerceIn(0, totalInstallments)

                        val totalPlannedCents = f.installmentAmountCents * totalInstallments.toLong()
                        val pagatoCents = (f.installmentAmountCents * paidInstallments.toLong()).coerceAtMost(totalPlannedCents)
                        val remainingCents = (totalPlannedCents - pagatoCents).coerceAtLeast(0L)
                        val progress = if (totalPlannedCents > 0L) (pagatoCents.toFloat() / totalPlannedCents.toFloat()).coerceIn(0f, 1f) else 0f

                        val dueDay = f.smartDueDay
                        val percentComplete = (progress * 100).toInt()
                        val catName = categories.firstOrNull { it.id == f.categoryId }?.name ?: "ALTRO"

                        LaunchedEffect(remainingCents, f.isClosed) {
                            if (remainingCents <= 0L && totalPlannedCents > 0L && !f.isClosed) {
                                val updatedFin = f.copy(isClosed = true, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                safeScope.launch {
                                    viewModel.saveFinancing(updatedFin)
                                    onChanged()
                                }
                            }
                        }

                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null) {
                                    detailsFinancing = f
                                }
                                .padding(vertical = 4.dp)
                        ) {
                            Row(modifier = Modifier.padding(vertical = 12.dp, horizontal = 4.dp), verticalAlignment = Alignment.CenterVertically) {
                                TxLogo(f.logoEmoji, f.logoUri, f.creditorName ?: f.name, Modifier.size(40.dp))
                                Spacer(Modifier.width(16.dp))
                                Column(Modifier.weight(1f)) {
                                    Text(text = f.name.uppercase(), style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), color = if (!f.isClosed) Color.White else Color(0xFFA0A0A0), maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(
                                        text = "${f.creditorName?.uppercase() ?: "RATEALE"} • Giorno $dueDay • $catName • $percentComplete%",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = Color(0xFFA0A0A0),
                                        maxLines = 1,
                                        modifier = Modifier.basicMarquee()
                                    )
                                }

                                val rowColor = if (!f.isClosed) Color.White else Color(0xFFA0A0A0)
                                ModernMoneyText(
                                    cents = f.installmentAmountCents,
                                    hideBalances = hideFinancingAmounts,
                                    color = rowColor,
                                    integerFontSize = 16.sp,
                                    decimalFontSize = 12.sp,
                                    symbolFontSize = 12.sp,
                                    modifier = Modifier.padding(end = 8.dp)
                                )
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
                        }
                    }
                }
                item { Spacer(Modifier.height(120.dp)) }
            }
        }
    }

    if (showDetailsSheet) {
        DebtDetailsBottomSheet(
            capitaleIniziale = totalRemainingCents + totalPaidCents,
            giaPagato = totalPaidCents,
            hideBalances = hideFinancingAmounts,
            onDismiss = { showDetailsSheet = false },
            onNuovoClick = { showDetailsSheet = false; creating = true },
            onSimulatoreClick = { showDetailsSheet = false; showSimulator = true },
            onVerificaClick = { showDetailsSheet = false; triggerGeneration() }
        )
    }

    // ==========================================
    // 🚀 POPUP DETTAGLI FINANZIAMENTO
    // ==========================================
    var isFinancingDetailsVisible by remember { mutableStateOf(false) }

    LaunchedEffect(detailsFinancing) {
        if (detailsFinancing != null) {
            activeDetailsFinancing = detailsFinancing
            isFinancingDetailsVisible = true
        } else {
            isFinancingDetailsVisible = false
        }
    }

    LaunchedEffect(isFinancingDetailsVisible) {
        if (!isFinancingDetailsVisible && activeDetailsFinancing != null) {
            delay(220)
            detailsFinancing = null
            activeDetailsFinancing = null
        }
    }

    val dismissFinancingDetails = {
        isFinancingDetailsVisible = false
    }

    activeDetailsFinancing?.let { f ->
        val totalInstallments = safeCalculateTotalInstallments(f)
        val calendarPaid = safeCalculatePaidInstallments(f, Clock.System.todayIn(TimeZone.currentSystemDefault()))

        val earlyPaidTxs = txs.count {
            !it.isDeleted &&
                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                    it.dateEpochDay > todayEpochDays
        }

        val deletedCalendarTxs = txs.count {
            it.isDeleted &&
                    (it.merchantKey?.contains("[fin:${f.id}]") == true || it.description?.contains("[fin:${f.id}]") == true) &&
                    it.dateEpochDay <= todayEpochDays
        }

        val paidInstallments = (calendarPaid - deletedCalendarTxs + earlyPaidTxs).coerceIn(0, totalInstallments)

        val totalPlannedCents = f.installmentAmountCents * totalInstallments.toLong()
        val pagatoCents = (f.installmentAmountCents * paidInstallments.toLong()).coerceAtMost(totalPlannedCents)
        val remainingCents = (totalPlannedCents - pagatoCents).coerceAtLeast(0L)

        val progress = if (totalInstallments > 0) paidInstallments.toFloat() / totalInstallments.toFloat() else 0f
        val percentStr = "${(progress * 100).toInt()}%"

        val startDate = try { LocalDate.fromEpochDays(f.startEpochDay.toInt()) } catch (_: Throwable) { Clock.System.todayIn(TimeZone.currentSystemDefault()) }
        val startDateStr = "${startDate.dayOfMonth.toString().padStart(2, '0')}/${startDate.monthNumber.toString().padStart(2, '0')}/${startDate.year}"

        val endDate = try { LocalDate.fromEpochDays(f.endEpochDay.toInt()) } catch (_: Throwable) { Clock.System.todayIn(TimeZone.currentSystemDefault()) }
        val endDateStr = "${endDate.dayOfMonth.toString().padStart(2, '0')}/${endDate.monthNumber.toString().padStart(2, '0')}/${endDate.year}"

        Dialog(
            onDismissRequest = { dismissFinancingDetails() },
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            AnimatedVisibility(
                visible = isFinancingDetailsVisible,
                enter = fadeIn(tween(250)) + scaleIn(initialScale = 0.82f, animationSpec = spring(dampingRatio = Spring.DampingRatioMediumBouncy, stiffness = Spring.StiffnessLow)) + slideInVertically(initialOffsetY = { it / 3 }),
                exit = fadeOut(tween(200)) + scaleOut(targetScale = 0.85f) + slideOutVertically(targetOffsetY = { it / 3 })
            ) {
                Surface(
                    modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 420.dp),
                    shape = RoundedCornerShape(28.dp),
                    color = Color.White.copy(alpha = 0.12f),
                    border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.40f)),
                    shadowElevation = 0.dp
                ) {
                    Column(modifier = Modifier.fillMaxWidth().padding(24.dp)) {

                        Row(verticalAlignment = Alignment.CenterVertically) {
                            TxLogo(f.logoEmoji, f.logoUri, f.creditorName ?: f.name, Modifier.size(54.dp))
                            Spacer(Modifier.width(16.dp))
                            Column(modifier = Modifier.weight(1f)) {
                                Text(text = f.name.uppercase(), style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black, letterSpacing = 0.5.sp), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                Text(text = f.creditorName?.uppercase() ?: "RATEALE", style = MaterialTheme.typography.bodySmall, color = brandPrimary, fontWeight = FontWeight.Bold)
                            }
                        }

                        Spacer(Modifier.height(20.dp))

                        Column(modifier = Modifier.fillMaxWidth()) {
                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Bottom) {
                                Text("Stato Pagamenti", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                Text(percentStr, style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.ExtraBold), color = brandPrimary)
                            }
                            Spacer(Modifier.height(8.dp))
                            LinearProgressIndicator(
                                progress = { progress },
                                modifier = Modifier.fillMaxWidth().height(8.dp).clip(CircleShape),
                                color = brandPrimary,
                                trackColor = Color.White.copy(alpha = 0.1f)
                            )
                        }

                        Spacer(Modifier.height(20.dp))

                        @Composable
                        fun InfoRow(label: String, value: String = "", isBold: Boolean = false, color: Color = Color.White, moneyCents: Long? = null) {
                            Row(modifier = Modifier.fillMaxWidth().padding(vertical = 5.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Bottom) {
                                Text(label, style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                                if (moneyCents != null) {
                                    ModernMoneyText(cents = moneyCents, hideBalances = false, color = color, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                                } else {
                                    Text(value, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = if(isBold) FontWeight.ExtraBold else FontWeight.Medium), color = color)
                                }
                            }
                        }

                        InfoRow("Inizio", startDateStr)
                        InfoRow("Fine prevista", endDateStr)
                        InfoRow("Piano rate", "$paidInstallments su $totalInstallments pagate")

                        Spacer(Modifier.height(12.dp))

                        Surface(
                            modifier = Modifier.fillMaxWidth(),
                            color = Color.White.copy(alpha = 0.08f),
                            shape = RoundedCornerShape(16.dp),
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                        ) {
                            Column(Modifier.padding(16.dp)) {
                                InfoRow("Totale Finanziato", moneyCents = totalPlannedCents, color = Color.White)
                                InfoRow("Totale Pagato", moneyCents = pagatoCents, color = Color(0xFF10B981))
                                InfoRow("Residuo da versare", moneyCents = remainingCents, color = MaterialTheme.colorScheme.error)
                            }
                        }

                        Spacer(Modifier.height(20.dp))

                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier.clickable(indication = null, interactionSource = remember { MutableInteractionSource() }) { dismissFinancingDetails(); financingToDelete = f }
                            ) {
                                Surface(shape = RoundedCornerShape(50), color = MaterialTheme.colorScheme.error.copy(alpha = 0.15f), modifier = Modifier.size(48.dp)) {
                                    Icon(Icons.Outlined.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error, modifier = Modifier.padding(12.dp))
                                }
                                Spacer(Modifier.height(6.dp))
                                Text("Elimina", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.SemiBold), color = MaterialTheme.colorScheme.error)
                            }

                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier.clickable(indication = null, interactionSource = remember { MutableInteractionSource() }) { dismissFinancingDetails(); editingFin = f }
                            ) {
                                Surface(shape = RoundedCornerShape(50), color = brandPrimary.copy(alpha = 0.15f), modifier = Modifier.size(48.dp)) {
                                    Icon(Icons.Outlined.Edit, contentDescription = "Modifica", tint = brandPrimary, modifier = Modifier.padding(12.dp))
                                }
                                Spacer(Modifier.height(6.dp))
                                Text("Modifica", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.SemiBold), color = brandPrimary)
                            }

                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier.clickable(indication = null, interactionSource = remember { MutableInteractionSource() }) { 
                                    dismissFinancingDetails()
                                    financingToToggleState = f
                                }
                            ) {
                                Surface(shape = RoundedCornerShape(50), color = brandPrimary.copy(alpha = 0.15f), modifier = Modifier.size(48.dp)) {
                                    Icon(if (f.isClosed) Icons.Outlined.Restore else Icons.Outlined.CheckCircle, contentDescription = if (f.isClosed) "Riattiva" else "Estingui", tint = brandPrimary, modifier = Modifier.padding(12.dp))
                                }
                                Spacer(Modifier.height(6.dp))
                                Text(if (f.isClosed) "Riattiva" else "Estingui", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = brandPrimary)
                            }
                        }

                        Spacer(Modifier.height(20.dp))
                        Button(
                            onClick = { dismissFinancingDetails() },
                            modifier = Modifier.fillMaxWidth().height(48.dp),
                            shape = RoundedCornerShape(14.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                        ) {
                            Text("CHIUDI", fontWeight = FontWeight.Bold)
                        }
                    }
                }
            }
        }
    }
}

    if (showSimulator) {
        LoanSimulatorDialog(
            onDismiss = { showSimulator = false },
            onSaveAsFinancing = { capitale, rataPura, commissioneBanca, mesi, startDateMillis, taegFin, creditor, purpose, logoEmoji, logoUri ->
                val nowMs = kotlinx.datetime.Clock.System.now().toEpochMilliseconds()

                val startEpochDay = startDateMillis / 86400000L
                val startDate = kotlinx.datetime.LocalDate.fromEpochDays(startEpochDay.toInt())

                val targetDay = startDate.dayOfMonth
                val endEpochDay = addMonths(startDate, mesi, targetDay).toEpochDays().toLong()

                val taegRounded = (taegFin * 100).roundToLong()
                val taegStr = "${taegRounded / 100}.${(taegRounded % 100).toString().padStart(2, '0')}"

                val finalPurpose = if (purpose.isNotBlank()) "$purpose\n(TAEG Finanziaria: $taegStr%)\n[DAY:$targetDay]" else "TAEG Finanziaria: $taegStr%\n[DAY:$targetDay]"

                val newFinancing = FinancingEntity(
                    id = "fin_$nowMs",
                    name = purpose.ifBlank { "NUOVO PRESTITO" }.uppercase(),
                    creditorName = creditor.ifBlank { "Banca / Finanziaria" }.uppercase(),
                    purpose = finalPurpose,
                    installmentAmountCents = rataPura,
                    commissionCents = commissioneBanca,
                    extraInstallmentCents = 0L,
                    extraInstallmentMonth = 0L,
                    totalAmountCents = rataPura * mesi.toLong(),
                    remainingAmountCents = rataPura * mesi.toLong(),
                    accountId = accounts.firstOrNull { !it.isArchived && it.isVisible }?.id ?: accounts.firstOrNull()?.id ?: "default",
                    categoryId = categories.firstOrNull { it.name.contains("Prestiti", true) }?.id ?: "default",
                    startEpochDay = startEpochDay,
                    endEpochDay = endEpochDay,
                    autoGenerateOnReminder = true,
                    isClosed = false,
                    isDeleted = false,
                    logoEmoji = logoEmoji ?: "🏦",
                    logoUri = logoUri ?: "",
                    createdAtEpochMs = nowMs,
                    updatedAtEpochMs = nowMs
                )

                safeScope.launch {
                    viewModel.saveFinancing(newFinancing)
                    showSimulator = false
                    onChanged()
                }
            }
        )
    }

    if (creating) {
        FinancingDialog(
            viewModel = viewModel,
            db = db, accounts = accounts, categories = categories, preferredAccountId = activeAccountId, existingFinancings = financings,
            onDismiss = { creating = false },
            onSave = { fin, txs -> safeScope.launch { viewModel.saveFinancingWithTransactions(fin, txs); creating = false; onChanged() } }
        )
    }
    editingFin?.let { ed ->
        FinancingDialog(
            viewModel = viewModel,
            db = db, accounts = accounts, categories = categories, initial = ed, existingFinancings = financings,
            onDismiss = { editingFin = null },
            onSave = { fin, txs -> safeScope.launch { viewModel.saveFinancingWithTransactions(fin, txs); editingFin = null; onChanged() } }
        )
    }

    if (financingToDelete != null) {
        val targetFin = financingToDelete!!
        AlertDialog(
            onDismissRequest = { financingToDelete = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Outlined.Delete,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.error,
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Elimina Finanziamento",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
            text = {
                Text(
                    "Vuoi eliminare definitivamente '${targetFin.name}' dall'archivio?\nQuesta operazione rimuoverà la linea di credito in modo permanente.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        safeScope.launch {
                            viewModel.saveFinancing(targetFin.copy(isDeleted = true))
                            financingToDelete = null
                            onChanged()
                        }
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = Color.White
                    )
                ) {
                    Text("ELIMINA DEFINITIVAMENTE", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { financingToDelete = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (financingToToggleState != null) {
        val targetFin = financingToToggleState!!
        val isClosing = !targetFin.isClosed
        val titleText = if (isClosing) "Estingui Finanziamento" else "Riattiva Finanziamento"
        val bodyText = if (isClosing) {
            "Sei sicuro di voler estinguere in anticipo il finanziamento '${targetFin.name}'?\nVerrà contrassegnato come saldato e archiviato nei debiti estinti."
        } else {
            "Sei sicuro di voler riattivare il finanziamento '${targetFin.name}'?\nTornerà attivo tra le linee di credito in corso."
        }

        AlertDialog(
            onDismissRequest = { financingToToggleState = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        if (isClosing) Icons.Outlined.CheckCircle else Icons.Outlined.Restore,
                        contentDescription = null,
                        tint = if (isClosing) Color(0xFF10B981) else Color(0xFF60A5FA),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        titleText,
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = { Text(bodyText, style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        val updatedFin = targetFin.copy(isClosed = isClosing, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                        safeScope.launch {
                            viewModel.saveFinancing(updatedFin)
                            onChanged()
                        }
                        financingToToggleState = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = if (isClosing) Color(0xFF10B981) else Color(0xFF60A5FA),
                        contentColor = Color.White
                    )
                ) {
                    Text(if (isClosing) "CONFERMA ESTINZIONE" else "CONFERMA RIATTIVAZIONE", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { financingToToggleState = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showGenerationFeedback) {
        AlertDialog(
            onDismissRequest = { showGenerationFeedback = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Rounded.CheckCircle, contentDescription = null, tint = Color(0xFF10B981), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Verifica Completata", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                }
            },
            text = { Text("Controllo delle scadenze terminato.\n\nSe non vedi nuove rate in lista, significa che non ci sono debiti in scadenza per questo ciclo o che sono già stati saldati.", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                TextButton(
                    onClick = { showGenerationFeedback = false }
                ) {
                    Text("HO CAPITO", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                }
            }
        )
    }
}

@Composable
fun ActionCard(
    modifier: Modifier = Modifier,
    title: String,
    icon: ImageVector,
    color: Color,
    onClick: () -> Unit
) {
    Surface(
        onClick = onClick,
        shape = RoundedCornerShape(16.dp),
        color = color.copy(alpha = 0.15f),
        border = BorderStroke(1.dp, color.copy(alpha = 0.2f)),
        modifier = modifier.height(80.dp)
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier.fillMaxSize()
        ) {
            Icon(
                imageVector = icon,
                contentDescription = title,
                tint = color,
                modifier = Modifier.size(24.dp)
            )
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                text = title,
                style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold),
                color = color
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DebtDetailsBottomSheet(
    capitaleIniziale: Long,
    giaPagato: Long,
    hideBalances: Boolean,
    onDismiss: () -> Unit,
    onNuovoClick: () -> Unit,
    onSimulatoreClick: () -> Unit,
    onVerificaClick: () -> Unit
) {
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)

    ModalBottomSheet(
        onDismissRequest = onDismiss,
        sheetState = sheetState,
        containerColor = Color.White.copy(alpha = 0.12f),
        shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 32.dp, start = 24.dp, end = 24.dp)
        ) {
            Text(
                text = "Dettagli Finanziamenti",
                style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                color = Color.White,
                modifier = Modifier.padding(bottom = 24.dp)
            )

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column {
                    Text(
                        text = "Capitale Iniziale",
                        style = MaterialTheme.typography.labelMedium,
                        color = Color(0xFFA0A0A0)
                    )
                    Spacer(Modifier.height(4.dp))
                    ModernMoneyText(
                        cents = capitaleIniziale,
                        hideBalances = hideBalances,
                        color = Color.White,
                        integerFontSize = 20.sp,
                        decimalFontSize = 14.sp,
                        symbolFontSize = 14.sp
                    )
                }

                Column(horizontalAlignment = Alignment.End) {
                    Text(
                        text = "Già Pagato",
                        style = MaterialTheme.typography.labelMedium,
                        color = Color(0xFFA0A0A0)
                    )
                    Spacer(Modifier.height(4.dp))
                    ModernMoneyText(
                        cents = giaPagato,
                        hideBalances = hideBalances,
                        color = Color(0xFF10B981),
                        integerFontSize = 20.sp,
                        decimalFontSize = 14.sp,
                        symbolFontSize = 14.sp
                    )
                }
            }

            Spacer(modifier = Modifier.height(32.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                ActionCard(
                    modifier = Modifier.weight(1f),
                    title = "Nuovo",
                    icon = Icons.Default.Add,
                    color = Color(0xFF60A5FA),
                    onClick = onNuovoClick
                )

                ActionCard(
                    modifier = Modifier.weight(1f),
                    title = "Simulatore",
                    icon = Icons.Rounded.Calculate,
                    color = Color(0xFF34D399),
                    onClick = onSimulatoreClick
                )

                ActionCard(
                    modifier = Modifier.weight(1f),
                    title = "Verifica",
                    icon = Icons.Rounded.AutoFixHigh,
                    color = Color(0xFFFBBF24),
                    onClick = onVerificaClick
                )
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FinancingDialog(
    viewModel: HomeViewModel,
    db: MonetixDatabase,
    accounts: List<AccountEntity>,
    categories: List<CategoryEntity>,
    existingFinancings: List<FinancingEntity> = emptyList(),
    preferredAccountId: String? = null,
    initial: FinancingEntity? = null,
    onDismiss: () -> Unit,
    onSave: (FinancingEntity, List<TransactionEntity>) -> Unit
) {
    val nowMs = Clock.System.now().toEpochMilliseconds()
    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val brandPrimary = Color(0xFF60A5FA)
    val scope = rememberCoroutineScope()

    val financingEligibleAccounts = remember(accounts) { accounts.filter { !it.isSavings && !it.isDeleted } }

    var nameText by remember(initial?.id) { mutableStateOf(initial?.name ?: "") }
    var creditorText by remember(initial?.id) { mutableStateOf(initial?.creditorName ?: "") }

    // 🚀 Nascondiamo il tag [DAY:X] dalla UI note all'utente
    var purposeText by remember(initial?.id) { mutableStateOf(initial?.purpose?.replace(Regex("\\[DAY:\\d+\\]"), "")?.trim() ?: "") }

    val initInst = if (initial != null) (initial.installmentAmountCents / 100.0).toString() else ""
    var installmentText by remember(initial?.id) { mutableStateOf(initInst) }

    val initComm = if (initial != null && (initial.commissionCents ?: 0L) > 0L) ((initial.commissionCents ?: 0L) / 100.0).toString() else ""
    var commissionText by remember(initial?.id) { mutableStateOf(initComm) }

    val initExt = if (initial != null && (initial.extraInstallmentCents ?: 0L) > 0L) ((initial.extraInstallmentCents ?: 0L) / 100.0).toString() else ""
    var extraInstallmentText by remember(initial?.id) { mutableStateOf(initExt) }

    var activeAmountTarget by remember { mutableStateOf(AmountTarget.NONE) }
    var extraInstallmentMonth by remember(initial?.id) { mutableStateOf(initial?.extraInstallmentMonth?.toInt()) }
    var extraMonthMenuOpen by remember { mutableStateOf(false) }

    var logoEmoji by remember(initial?.id) { mutableStateOf(initial?.logoEmoji ?: "") }
    var logoUri by remember(initial?.id) { mutableStateOf(initial?.logoUri ?: "") }
    var manualLogoSet by remember { mutableStateOf(initial?.logoUri != null || initial?.logoEmoji != null) }

    var autoGenerateOnReminder by remember(initial?.id) { mutableStateOf(initial?.autoGenerateOnReminder ?: true) }

    var showEmojiInput by remember { mutableStateOf(false) }
    var showWebSearch by remember { mutableStateOf(false) }

    var showDatePicker by remember { mutableStateOf(false) }

    val dateInteractionSource = remember { MutableInteractionSource() }
    val isDateFocused by dateInteractionSource.collectIsFocusedAsState()

    var startDateText by remember(initial?.id) {
        val dateString = initial?.let { LocalDate.fromEpochDays(it.startEpochDay.toInt()).let { d -> formatKmpDate(d) } } ?: formatKmpDate(today)
        mutableStateOf(dateString)
    }

    // 🚀 NUOVO CAMPO: GIORNO DI ADDEBITO GLOBALE
    var targetDayText by remember(initial?.id) {
        val derived = initial?.smartDueDay ?: try { parseDayMonthYearToEpochDayOrNull(startDateText)?.let { LocalDate.fromEpochDays(it.toInt()).dayOfMonth } ?: 1 } catch(e: Exception) { 1 }
        mutableStateOf(derived.toString())
    }

    LaunchedEffect(isDateFocused) {
        if (isDateFocused) {
            startDateText = ""
        }
    }

    val onDateChange: (String) -> Unit = { newVal ->
        val oldText = startDateText
        if (newVal.length < oldText.length) {
            startDateText = newVal
        } else {
            val clean = newVal.replace("/", "").filter { it.isDigit() }
            startDateText = buildString {
                for (i in clean.indices) {
                    append(clean[i])
                    if ((i == 1 || i == 3) && i < 7) append("/")
                }
            }.take(10)
        }
    }

    val datePickerState = rememberDatePickerState(
        initialSelectedDateMillis = parseDayMonthYearToEpochDayOrNull(startDateText)?.toLong()?.times(86400000L)
    )

    var showOldFinancingPrompt by remember { mutableStateOf(false) }
    var pendingFinancing by remember { mutableStateOf<FinancingEntity?>(null) }
    var arrearsCountText by remember { mutableStateOf("") }

    val initialDurationMonths = initial?.let { safeCalculateTotalInstallments(it) } ?: 12
    var durationMonthsText by remember(initial?.id) { mutableStateOf(initialDurationMonths.toString()) }

    var accountMenuOpen by remember { mutableStateOf(false) }
    var selectedAccountId by remember(financingEligibleAccounts, initial?.id, preferredAccountId) {
        mutableStateOf(initial?.accountId ?: financingEligibleAccounts.firstOrNull { it.id == preferredAccountId }?.id ?: financingEligibleAccounts.firstOrNull { !it.isArchived && it.isVisible }?.id ?: "")
    }

    val initialCategoryName = categories.firstOrNull { it.id == initial?.categoryId }?.name ?: ""
    var categorySearchText by remember(initial?.id) { mutableStateOf(initialCategoryName) }
    var categoryMenuOpen by remember { mutableStateOf(false) }

    val catInteractionSource = remember { MutableInteractionSource() }
    val isCatFocused by catInteractionSource.collectIsFocusedAsState()

    var creditorSuggestionsExpanded by remember { mutableStateOf(false) }
    val creditorInteractionSource = remember { MutableInteractionSource() }
    val isCreditorFocused by creditorInteractionSource.collectIsFocusedAsState()

    val dynamicCreditorSuggestions = remember(existingFinancings) {
        val userCreditors = existingFinancings
            .filter { !it.isDeleted && !it.creditorName.isNullOrBlank() }
            .map {
                FinancingPredefCreditor(
                    name = it.creditorName!!,
                    domain = null,
                    customUrl = it.logoUri,
                    customEmoji = it.logoEmoji
                )
            }
        (userCreditors + defaultCreditorSuggestions).distinctBy { it.name.uppercase().trim() }
    }

    LaunchedEffect(isCatFocused) {
        if (isCatFocused) {
            if (categorySearchText == "NESSUNA CATEGORIA") categorySearchText = ""
            categoryMenuOpen = true
        }
    }

    val currentCleanCreditor = creditorText.trim()
    val smartMatch = dynamicCreditorSuggestions.firstOrNull { it.name.equals(currentCleanCreditor, ignoreCase = true) }
        ?: dynamicCreditorSuggestions.firstOrNull { currentCleanCreditor.length >= 3 && it.name.contains(currentCleanCreditor, ignoreCase = true) }

    val finalEmojiToSave = if (manualLogoSet && logoEmoji.isNotBlank()) logoEmoji else smartMatch?.customEmoji
    val finalUriToSave = if (manualLogoSet && logoUri.isNotBlank()) logoUri else smartMatch?.url ?: autoFaviconUrlForName(if (currentCleanCreditor.isNotBlank()) currentCleanCreditor else nameText)

    var error by remember { mutableStateOf<String?>(null) }
    val mesiItaliano = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")

    val mediaHandler = rememberMediaHandler(
        onImageResult = { uri ->
            if (uri != null) {
                logoUri = uri.toString()
                logoEmoji = ""
                manualLogoSet = true
                showEmojiInput = false
            }
        },
        onVoiceResult = { }
    )

    fun parseCents() = installmentText.replace(',', '.').trim().toDoubleOrNull()?.let { (it * 100.0).roundToLong() }
    fun parseCommissionCents() = commissionText.replace(',', '.').trim().takeIf { it.isNotBlank() }?.toDoubleOrNull()?.let { (it * 100.0).roundToLong() } ?: 0L
    fun parseExtraInstallmentCents() = extraInstallmentText.replace(',', '.').trim().takeIf { it.isNotBlank() }?.toDoubleOrNull()?.let { (it * 100.0).roundToLong() } ?: 0L
    fun parseDateOrNull(raw: String) = parseDayMonthYearToEpochDayOrNull(raw)?.let { LocalDate.fromEpochDays(it.toInt()) }

    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
            dismissOnClickOutside = true,
            dismissOnBackPress = true
        )
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .imePadding()
                .systemBarsPadding(),
            contentAlignment = Alignment.Center
        ) {
            Surface(
                modifier = Modifier
                    .padding(horizontal = 16.dp, vertical = 24.dp)
                    .fillMaxWidth()
                    .widthIn(max = 450.dp)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = { creditorSuggestionsExpanded = false; categoryMenuOpen = false }
                    ),
                shape = RoundedCornerShape(28.dp),
                color = Color.White.copy(alpha = 0.12f),
                border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.40f)),
                shadowElevation = 24.dp
            ) {
                Column(modifier = Modifier.fillMaxWidth()) {

                    Column(modifier = Modifier.fillMaxWidth().padding(top = 24.dp, start = 24.dp, end = 24.dp, bottom = 8.dp)) {
                        Text(
                            text = (if (initial == null) "Nuovo Debito" else "Modifica Debito").uppercase(),
                            style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                            color = Color.White
                        )
                        Spacer(Modifier.height(8.dp))
                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.1f))
                    }

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f, fill = false)
                            .verticalScroll(rememberScrollState())
                            .padding(horizontal = 24.dp, vertical = 16.dp)
                            .animateContentSize(),
                        verticalArrangement = Arrangement.spacedBy(24.dp)
                    ) {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Text("LOGO E ICONA", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(16.dp)) {

                                val fallbackForLogo = if (creditorText.isNotBlank()) creditorText else if (nameText.isNotBlank()) nameText else "DEBITO"
                                TxLogo(
                                    logoEmoji = finalEmojiToSave,
                                    logoUri = finalUriToSave,
                                    name = fallbackForLogo,
                                    Modifier.size(54.dp)
                                )

                                FlowRow(
                                    modifier = Modifier.weight(1f),
                                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                                    verticalArrangement = Arrangement.spacedBy(6.dp)
                                ) {
                                    OutlinedButton(
                                        onClick = { mediaHandler.launchGallery() },
                                        modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp),
                                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.2f)),
                                        contentPadding = PaddingValues(horizontal = 12.dp)
                                    ) { Text("FOTO", style = MaterialTheme.typography.labelSmall, color = Color.White) }

                                    OutlinedButton(
                                        onClick = { showEmojiInput = !showEmojiInput; showWebSearch = false },
                                        modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp),
                                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.2f)),
                                        contentPadding = PaddingValues(horizontal = 12.dp)
                                    ) { Text("EMOJI", style = MaterialTheme.typography.labelSmall, color = Color.White) }

                                    OutlinedButton(
                                        onClick = { showWebSearch = true; showEmojiInput = false },
                                        modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp),
                                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.2f)),
                                        contentPadding = PaddingValues(horizontal = 12.dp)
                                    ) { Text("WEB", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                }
                            }

                            AnimatedVisibility(visible = showEmojiInput) {
                                StableWebTextField(
                                    value = logoEmoji,
                                    onValueChange = {
                                        if(it.length <= 3) {
                                            logoEmoji = it
                                            logoUri = ""
                                            manualLogoSet = true
                                        }
                                    },
                                    label = "Inserisci Emoji"
                                )
                            }
                        }

                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Text("DETTAGLI", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))

                            StableWebTextField(value = nameText, onValueChange = { nameText = it }, label = "NOME (es. AUTO, PC)")

                            Column(modifier = Modifier.fillMaxWidth()) {
                                Box(modifier = Modifier.fillMaxWidth()) {
                                    StableWebTextField(
                                        value = creditorText,
                                        onValueChange = {
                                            creditorText = it
                                            creditorSuggestionsExpanded = it.isNotBlank()
                                        },
                                        label = "CREDITORE (es. AGOS, COMPASS)",
                                        interactionSource = creditorInteractionSource
                                    )

                                    val filteredCreditors = dynamicCreditorSuggestions.filter {
                                        it.name.contains(creditorText, ignoreCase = true)
                                    }

                                    DropdownMenu(
                                        expanded = creditorSuggestionsExpanded && filteredCreditors.isNotEmpty() && isCreditorFocused,
                                        onDismissRequest = { creditorSuggestionsExpanded = false },
                                        properties = PopupProperties(focusable = false),
                                        modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 220.dp).background(Color(0xFF1C1C1E))
                                    ) {
                                        filteredCreditors.take(5).forEach { cred ->
                                            DropdownMenuItem(
                                                text = { Text(cred.name, fontWeight = FontWeight.SemiBold, color = Color.White) },
                                                leadingIcon = {
                                                    when {
                                                        cred.url != null -> AsyncImage(model = cred.url, contentDescription = null, modifier = Modifier.size(24.dp))
                                                        cred.customEmoji != null -> Text(cred.customEmoji, fontSize = 20.sp)
                                                        else -> Icon(Icons.Default.AccountBalanceWallet, null, modifier = Modifier.size(24.dp), tint = Color.White)
                                                    }
                                                },
                                                onClick = {
                                                    creditorText = cred.name
                                                    logoUri = ""
                                                    logoEmoji = ""
                                                    manualLogoSet = false
                                                    creditorSuggestionsExpanded = false
                                                }
                                            )
                                        }
                                    }
                                }

                                AnimatedVisibility(visible = creditorText.isBlank()) {
                                    Column(modifier = Modifier.padding(top = 12.dp)) {
                                        Text("Finanziarie frequenti:", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                        Spacer(Modifier.height(8.dp))
                                        LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                            items(dynamicCreditorSuggestions.take(8)) { cred ->
                                                FilterChip(
                                                    selected = false,
                                                    onClick = {
                                                        creditorText = cred.name
                                                        logoUri = ""
                                                        logoEmoji = ""
                                                        manualLogoSet = false
                                                    },
                                                    label = { Text(cred.name, style = MaterialTheme.typography.bodySmall, color = Color.White) },
                                                    colors = FilterChipDefaults.filterChipColors(containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White),
                                                    border = null,
                                                    leadingIcon = {
                                                        when {
                                                            cred.url != null -> AsyncImage(model = cred.url, contentDescription = null, modifier = Modifier.size(16.dp))
                                                            cred.customEmoji != null -> Text(cred.customEmoji, fontSize = 14.sp)
                                                        }
                                                    },
                                                    shape = RoundedCornerShape(16.dp)
                                                )
                                            }
                                        }
                                    }
                                }
                            }

                            StableWebTextField(value = purposeText, onValueChange = { purposeText = it }, label = "NOTE (Opzionale)", minLines = 2)

                            Box(modifier = Modifier.fillMaxWidth()) {
                                StableWebTextField(
                                    value = categorySearchText,
                                    onValueChange = {
                                        categorySearchText = it
                                        categoryMenuOpen = true
                                    },
                                    label = "CATEGORIA",
                                    interactionSource = catInteractionSource,
                                    trailingIcon = {
                                        IconButton(onClick = { categoryMenuOpen = !categoryMenuOpen }) {
                                            Icon(if (categoryMenuOpen) Icons.Default.ExpandLess else Icons.Default.ExpandMore, contentDescription = null, tint = Color.White)
                                        }
                                    }
                                )

                                DropdownMenu(
                                    expanded = categoryMenuOpen && isCatFocused,
                                    onDismissRequest = { categoryMenuOpen = false },
                                    properties = PopupProperties(focusable = false),
                                    modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 220.dp).background(Color(0xFF1C1C1E))
                                ) {
                                    DropdownMenuItem(
                                        text = { Text("Nessuna categoria", color = Color.White) },
                                        colors = MenuDefaults.itemColors(textColor = Color.White),
                                        onClick = { categorySearchText = ""; categoryMenuOpen = false }
                                    )

                                    val filtered = categories.filter { !it.isDeleted && it.name.contains(categorySearchText, ignoreCase = true) }

                                    if (categorySearchText.isNotBlank() && filtered.none { it.name.equals(categorySearchText, ignoreCase = true) }) {
                                        DropdownMenuItem(
                                            text = { Text("+ Crea \"${categorySearchText.uppercase()}\"", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold) },
                                            colors = MenuDefaults.itemColors(textColor = Color(0xFF60A5FA)),
                                            onClick = {
                                                val catTextClean = categorySearchText.trim().uppercase()
                                                val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                                                val newId = "cat_$norm"
                                                val newCat = CategoryEntity(newId, catTextClean, false, nowMs, nowMs)
                                                scope.launch {
                                                    db.categoryQueries.upsert(id = newId, name = catTextClean, isDeleted = false, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs)
                                                    try { viewModel.firestore.salva("categorie", newId, newCat) } catch(e: Exception){}
                                                }
                                                categorySearchText = catTextClean
                                                categoryMenuOpen = false
                                            }
                                        )
                                    }

                                    filtered.forEach { c ->
                                        DropdownMenuItem(
                                            text = { Text(c.name, color = Color.White) },
                                            trailingIcon = {
                                                IconButton(
                                                    onClick = {
                                                        scope.launch(Dispatchers.Default) {
                                                            val updatedEpoch = Clock.System.now().toEpochMilliseconds()
                                                            db.categoryQueries.upsert(
                                                                id = c.id,
                                                                name = c.name,
                                                                isDeleted = true,
                                                                createdAtEpochMs = c.createdAtEpochMs,
                                                                updatedAtEpochMs = updatedEpoch
                                                            )
                                                            val deletedCat = c.copy(isDeleted = true, updatedAtEpochMs = updatedEpoch)
                                                            try { viewModel.firestore.salva("categorie", c.id, deletedCat) } catch(e: Exception){}
                                                        }
                                                        if (categorySearchText == c.name) categorySearchText = ""
                                                    }
                                                ) {
                                                    Icon(Icons.Outlined.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(20.dp))
                                                }
                                            },
                                            onClick = { categorySearchText = c.name; categoryMenuOpen = false }
                                        )
                                    }
                                }
                            }
                        }

                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Text("IMPORTI E RATE", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))

                            Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                                OutlinedTextField(
                                    value = installmentText,
                                    onValueChange = { installmentText = it },
                                    label = { Text("RATA (€)", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) },
                                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                    modifier = Modifier.fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp),
                                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = brandPrimary, unfocusedBorderColor = Color.White.copy(alpha = 0.20f), focusedLabelColor = brandPrimary, unfocusedLabelColor = Color(0xFFA0A0A0)),
                                    textStyle = LocalTextStyle.current.copy(fontWeight = FontWeight.Bold, color = brandPrimary),
                                    trailingIcon = {
                                        IconButton(onClick = { activeAmountTarget = AmountTarget.INSTALLMENT }) {
                                            Icon(Icons.Default.MoreVert, contentDescription = "Rotelle", tint = brandPrimary)
                                        }
                                    }
                                )

                                OutlinedTextField(
                                    value = commissionText,
                                    onValueChange = { commissionText = it },
                                    label = { Text("COMMISS. (€)", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) },
                                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                    modifier = Modifier.fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp),
                                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = brandPrimary, unfocusedBorderColor = Color.White.copy(alpha = 0.20f), focusedLabelColor = brandPrimary, unfocusedLabelColor = Color(0xFFA0A0A0)),
                                    trailingIcon = {
                                        IconButton(onClick = { activeAmountTarget = AmountTarget.COMMISSION }) {
                                            Icon(Icons.Default.MoreVert, contentDescription = "Rotelle", tint = brandPrimary)
                                        }
                                    }
                                )
                            }

                            Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                                OutlinedTextField(
                                    value = extraInstallmentText,
                                    onValueChange = { extraInstallmentText = it },
                                    label = { Text("EXTRA RATA", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) },
                                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                    modifier = Modifier.fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp),
                                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = brandPrimary, unfocusedBorderColor = Color.White.copy(alpha = 0.20f), focusedLabelColor = brandPrimary, unfocusedLabelColor = Color(0xFFA0A0A0)),
                                    trailingIcon = {
                                        IconButton(onClick = { activeAmountTarget = AmountTarget.EXTRA }) {
                                            Icon(Icons.Default.MoreVert, contentDescription = "Rotelle", tint = brandPrimary)
                                        }
                                    }
                                )

                                ExposedDropdownMenuBox(
                                    expanded = extraMonthMenuOpen,
                                    onExpandedChange = { extraMonthMenuOpen = !extraMonthMenuOpen },
                                    modifier = Modifier.fillMaxWidth()
                                ) {
                                    OutlinedTextField(
                                        value = extraInstallmentMonth?.let { mesiItaliano.getOrNull(it - 1)?.uppercase() } ?: "NESSUNO",
                                        onValueChange = {}, readOnly = true,
                                        label = { Text("MESE EXTRA", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) },
                                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = extraMonthMenuOpen) },
                                        modifier = Modifier.menuAnchor().fillMaxWidth(),
                                        shape = RoundedCornerShape(12.dp),
                                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = brandPrimary, unfocusedBorderColor = Color.White.copy(alpha = 0.20f), focusedLabelColor = brandPrimary, unfocusedLabelColor = Color(0xFFA0A0A0))
                                    )
                                    ExposedDropdownMenu(expanded = extraMonthMenuOpen, onDismissRequest = { extraMonthMenuOpen = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) {
                                        DropdownMenuItem(text = { Text("NESSUNO", color = Color.White) }, onClick = { extraInstallmentMonth = null; extraMonthMenuOpen = false })
                                        mesiItaliano.forEachIndexed { index, mese ->
                                            DropdownMenuItem(text = { Text(mese.uppercase(), color = Color.White) }, onClick = { extraInstallmentMonth = index + 1; extraMonthMenuOpen = false })
                                        }
                                    }
                                }
                            }
                        }

                        HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Text("CONTO E SCADENZE", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))

                            ExposedDropdownMenuBox(
                                expanded = accountMenuOpen,
                                onExpandedChange = { accountMenuOpen = !accountMenuOpen }
                            ) {
                                val selName = stripSystemMarker(financingEligibleAccounts.firstOrNull { it.id == selectedAccountId }?.name) ?: "SELEZIONA CONTO"
                                OutlinedTextField(
                                    value = selName, onValueChange = {}, readOnly = true,
                                    label = { Text("CONTO ADDEBITO", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0)) },
                                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = accountMenuOpen) },
                                    modifier = Modifier.menuAnchor().fillMaxWidth(),
                                    shape = RoundedCornerShape(12.dp),
                                    colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = brandPrimary, unfocusedBorderColor = Color.White.copy(alpha = 0.20f), focusedLabelColor = brandPrimary, unfocusedLabelColor = Color(0xFFA0A0A0))
                                )
                                ExposedDropdownMenu(expanded = accountMenuOpen, onDismissRequest = { accountMenuOpen = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) {
                                    financingEligibleAccounts.filter { (!it.isArchived && !it.isDeleted) || it.id == selectedAccountId }.forEach { a ->
                                        DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedAccountId = a.id; accountMenuOpen = false })
                                    }
                                }
                            }

                            // 🚀 MODIFICATO PER SUPPORTARE IL CAMPO DEL GIORNO SGANCIATO
                            Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                                StableWebTextField(
                                    value = startDateText,
                                    onValueChange = onDateChange,
                                    label = "DATA PRIMA RATA",
                                    keyboardType = KeyboardType.Number,
                                    modifier = Modifier.fillMaxWidth(),
                                    interactionSource = dateInteractionSource,
                                    trailingIcon = {
                                        IconButton(onClick = { showDatePicker = true }) {
                                            Icon(Icons.Default.DateRange, contentDescription = "Scegli Data", tint = brandPrimary)
                                        }
                                    }
                                )
                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                                    StableWebTextField(
                                        value = targetDayText,
                                        onValueChange = { if (it.all { c -> c.isDigit() }) targetDayText = it.take(2) },
                                        label = "GIORNO MENSILE (1-31)",
                                        keyboardType = KeyboardType.Number,
                                        modifier = Modifier.weight(1f)
                                    )
                                    StableWebTextField(
                                        value = durationMonthsText,
                                        onValueChange = { durationMonthsText = it.filter { c -> c.isDigit() }.take(3) },
                                        label = "DURATA (MESI)",
                                        keyboardType = KeyboardType.Number,
                                        modifier = Modifier.weight(1f)
                                    )
                                }
                            }

                            Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                Column(modifier = Modifier.weight(1f)) {
                                    Text("Generazione automatica", style = MaterialTheme.typography.labelMedium, color = Color.White)
                                    Text("Crea rata prima della scadenza", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                }
                                MonetixGlassSwitch(checked = autoGenerateOnReminder, onCheckedChange = { autoGenerateOnReminder = it }, activeColor = brandPrimary)
                            }

                            error?.let { Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall, fontWeight = FontWeight.Bold) }
                        }
                    }

                    Row(
                        modifier = Modifier.fillMaxWidth().padding(start = 24.dp, end = 24.dp, bottom = 16.dp, top = 8.dp),
                        horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically
                    ) {
                        TextButton(onClick = onDismiss) { Text("ANNULLA", style = MaterialTheme.typography.labelMedium, color = Color(0xFFA0A0A0)) }
                        Spacer(Modifier.width(12.dp))
                        Button(
                            onClick = {
                                scope.launch {
                                    val cents = parseCents(); val start = parseDateOrNull(startDateText); val dur = durationMonthsText.toIntOrNull()
                                    if (nameText.isBlank()) { error = "Inserisci un nome"; return@launch }
                                    if (cents == null) { error = "Rata non valida"; return@launch }
                                    if (start == null || dur == null || dur <= 0) { error = "Dati scadenze non validi"; return@launch }

                                    var finalCategoryId: String = initial?.categoryId ?: "default"
                                    val catTextClean = categorySearchText.trim().uppercase()

                                    if (catTextClean.isEmpty() || catTextClean == "NESSUNA CATEGORIA") {
                                        finalCategoryId = "default"
                                    } else if (catTextClean != initialCategoryName.uppercase()) {
                                        val existing = categories.firstOrNull { !it.isDeleted && it.name.equals(catTextClean, ignoreCase = true) }
                                        if (existing != null) {
                                            finalCategoryId = existing.id
                                        } else {
                                            val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                                            val newId = "cat_$norm"
                                            val newCat = CategoryEntity(newId, catTextClean, false, nowMs, nowMs)
                                            db.categoryQueries.upsert(id = newId, name = catTextClean, isDeleted = false, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs)
                                            try { viewModel.firestore.salva("categorie", newId, newCat) } catch(e: Exception){}
                                            finalCategoryId = newId
                                        }
                                    }

                                    val targetDay = targetDayText.toIntOrNull()?.coerceIn(1, 31) ?: start.dayOfMonth
                                    val cleanPurpose = purposeText.trim()
                                    // 🚀 FIX: Iniettiamo il tag [DAY:X] nel note per ricordarci sempre del giorno desiderato!
                                    val finalPurpose = if (cleanPurpose.isNotBlank()) "$cleanPurpose\n[DAY:$targetDay]" else "[DAY:$targetDay]"

                                    val totalCents = cents * dur.toLong()
                                    val isDateChanged = initial == null || start.toEpochDays().toLong() != initial.startEpochDay
                                    val createdEpochToUse = if (isDateChanged && start < today && autoGenerateOnReminder) {
                                        start.toEpochDays().toLong() * 86400000L
                                    } else {
                                        initial?.createdAtEpochMs ?: nowMs
                                    }

                                    val fin = FinancingEntity(
                                        id = initial?.id ?: "fin_${nowMs}",
                                        name = nameText.trim().uppercase(),
                                        creditorName = creditorText.trim().uppercase(),
                                        purpose = finalPurpose,
                                        installmentAmountCents = cents,
                                        commissionCents = parseCommissionCents(),
                                        extraInstallmentCents = parseExtraInstallmentCents(),
                                        extraInstallmentMonth = extraInstallmentMonth?.toLong(),
                                        totalAmountCents = totalCents,
                                        remainingAmountCents = initial?.remainingAmountCents ?: totalCents,
                                        accountId = selectedAccountId,
                                        categoryId = finalCategoryId,
                                        startEpochDay = start.toEpochDays().toLong(),
                                        endEpochDay = addMonths(start, dur - 1, targetDay).toEpochDays().toLong(),
                                        autoGenerateOnReminder = autoGenerateOnReminder,
                                        isClosed = initial?.isClosed ?: false,
                                        isDeleted = initial?.isDeleted ?: false,
                                        logoEmoji = finalEmojiToSave,
                                        logoUri = finalUriToSave,
                                        createdAtEpochMs = createdEpochToUse,
                                        updatedAtEpochMs = nowMs
                                    )

                                    if (isDateChanged && start < today && autoGenerateOnReminder) {
                                        val calculatedPassed = safeCalculatePaidInstallments(fin, today)
                                        arrearsCountText = calculatedPassed.toString()
                                        pendingFinancing = fin
                                        showOldFinancingPrompt = true
                                    } else {
                                        onSave(fin, emptyList())
                                    }
                                }
                            },
                            shape = RoundedCornerShape(12.dp), modifier = Modifier.height(44.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = brandPrimary, contentColor = Color.White)
                        ) { Text("SALVA", style = MaterialTheme.typography.labelMedium, color = Color.White) }
                    }
                }
            }
        }

        if (activeAmountTarget != AmountTarget.NONE) {
            val initialText = when (activeAmountTarget) {
                AmountTarget.INSTALLMENT -> installmentText
                AmountTarget.COMMISSION -> commissionText
                AmountTarget.EXTRA -> extraInstallmentText
                else -> "0.0"
            }
            val titleText = when (activeAmountTarget) {
                AmountTarget.INSTALLMENT -> "Importo Rata"
                AmountTarget.COMMISSION -> "Commissioni"
                AmountTarget.EXTRA -> "Extra Rata"
                else -> "Importo"
            }

            val parsedInitial = initialText.replace(',', '.').toDoubleOrNull() ?: 0.0
            var tempEuro by remember { mutableStateOf(kotlin.math.floor(parsedInitial).toInt().coerceIn(0, 5000)) }
            var tempCent by remember { mutableStateOf(((parsedInitial - kotlin.math.floor(parsedInitial)) * 100).roundToInt().coerceIn(0, 99)) }

            AlertDialog(
                onDismissRequest = { activeAmountTarget = AmountTarget.NONE },
                shape = RoundedCornerShape(28.dp),
                containerColor = Color.White.copy(alpha = 0.12f),
                title = { Text(titleText, fontWeight = FontWeight.Bold, color = brandPrimary) },
                text = {
                    Column(modifier = Modifier.fillMaxWidth().padding(top = 8.dp)) {
                        Text(
                            text = "${tempEuro}.${tempCent.toString().padStart(2, '0')} €",
                            style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.ExtraBold),
                            color = Color.White,
                            modifier = Modifier.align(Alignment.CenterHorizontally)
                        )
                        Spacer(Modifier.height(24.dp))

                        Row(
                            modifier = Modifier.fillMaxWidth().height(160.dp),
                            horizontalArrangement = Arrangement.Center,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            WheelPicker(
                                items = (0..5000).toList(),
                                initialValue = tempEuro,
                                onValueChanged = { tempEuro = it },
                                modifier = Modifier.weight(1f)
                            )
                            Text(",", style = MaterialTheme.typography.headlineLarge, color = Color.White, modifier = Modifier.padding(horizontal = 16.dp))
                            WheelPicker(
                                items = (0..99).toList(),
                                initialValue = tempCent,
                                onValueChanged = { tempCent = it },
                                modifier = Modifier.weight(1f),
                                labelExtractor = { it.toString().padStart(2, '0') }
                            )
                        }
                    }
                },
                confirmButton = {
                    TextButton(onClick = {
                        val newValue = "${tempEuro}.${tempCent.toString().padStart(2, '0')}"
                        when (activeAmountTarget) {
                            AmountTarget.INSTALLMENT -> installmentText = newValue
                            AmountTarget.COMMISSION -> commissionText = if (newValue == "0.00") "" else newValue
                            AmountTarget.EXTRA -> extraInstallmentText = if (newValue == "0.00") "" else newValue
                            else -> {}
                        }
                        activeAmountTarget = AmountTarget.NONE
                    }) { Text("CONFERMA", fontWeight = FontWeight.Bold, color = brandPrimary) }
                },
                dismissButton = {
                    TextButton(onClick = { activeAmountTarget = AmountTarget.NONE }) { Text("ANNULLA", color = Color(0xFFA0A0A0)) }
                }
            )
        }

        if (showDatePicker) {
            DatePickerDialog(
                onDismissRequest = { showDatePicker = false },
                colors = DatePickerDefaults.colors(containerColor = Color(0xFF1C1C1E)),
                confirmButton = {
                    TextButton(onClick = {
                        datePickerState.selectedDateMillis?.let { millis ->
                            val days = (millis / 86400000L).toInt()
                            val selectedDate = LocalDate.fromEpochDays(days)
                            startDateText = formatKmpDate(selectedDate)
                            targetDayText = selectedDate.dayOfMonth.toString()
                        }
                        showDatePicker = false
                    }) { Text("CONFERMA", fontWeight = FontWeight.Bold, color = brandPrimary) }
                },
                dismissButton = {
                    TextButton(onClick = { showDatePicker = false }) { Text("ANNULLA", color = Color(0xFFA0A0A0)) }
                }
            ) {
                DatePicker(
                    state = datePickerState,
                    title = { Text("Seleziona data", modifier = Modifier.padding(start = 24.dp, top = 24.dp), color = Color.White) },
                    colors = DatePickerDefaults.colors(
                        containerColor = Color(0xFF1C1C1E),
                        titleContentColor = Color.White,
                        headlineContentColor = Color.White,
                        weekdayContentColor = Color(0xFFA0A0A0),
                        dayContentColor = Color.White,
                        todayContentColor = brandPrimary,
                        todayDateBorderColor = brandPrimary,
                        selectedDayContentColor = Color.White,
                        selectedDayContainerColor = brandPrimary,
                        currentYearContentColor = Color.White,
                        selectedYearContentColor = Color.White,
                        selectedYearContainerColor = brandPrimary,
                        disabledDayContentColor = Color(0xFFA0A0A0).copy(alpha = 0.5f),
                        disabledSelectedDayContentColor = Color(0xFFA0A0A0).copy(alpha = 0.5f),
                        disabledSelectedDayContainerColor = brandPrimary.copy(alpha = 0.5f),
                        disabledSelectedYearContentColor = Color(0xFFA0A0A0).copy(alpha = 0.5f),
                        disabledSelectedYearContainerColor = brandPrimary.copy(alpha = 0.5f)
                    )
                )
            }
        }

        if (showWebSearch) {
            WebImagePickerPopup(
                initialQuery = creditorText.ifBlank { nameText },
                onDismiss = { showWebSearch = false },
                onImageSelected = { url ->
                    logoUri = url
                    logoEmoji = ""
                    manualLogoSet = true
                    showWebSearch = false
                }
            )
        }

        if (showOldFinancingPrompt && pendingFinancing != null) {
            AlertDialog(
                onDismissRequest = { showOldFinancingPrompt = false },
                shape = RoundedCornerShape(28.dp),
                containerColor = Color.White.copy(alpha = 0.12f),
                title = { Text("Registra Rate", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
                text = { Text("Vuoi registrare subito $arrearsCountText rata/e per allineare il tuo saldo?", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
                confirmButton = {
                    TextButton(onClick = {
                        val count = arrearsCountText.toIntOrNull() ?: 1
                        val financing = pendingFinancing!!
                        val start = LocalDate.fromEpochDays(financing.startEpochDay.toInt())

                        val listToSave = mutableListOf<TransactionEntity>()
                        val baseTime = Clock.System.now().toEpochMilliseconds()
                        val preferredDay = financing.smartDueDay

                        for (i in 0 until count) {
                            val txDate = addMonths(start, i, preferredDay)
                            val txEpochDay = txDate.toEpochDays().toLong()
                            val uniqueTime = baseTime + (i * 1000L)

                            var totalCentsForThisMonth = financing.installmentAmountCents + (financing.commissionCents ?: 0L)
                            var descSuffix = ""

                            if ((financing.extraInstallmentCents ?: 0L) > 0L && financing.extraInstallmentMonth?.toInt() == txDate.monthNumber) {
                                totalCentsForThisMonth += financing.extraInstallmentCents!!
                                descSuffix = " + Rata Extra"
                            }

                            listToSave.add(TransactionEntity(
                                id = "tx_arr_${i}_${uniqueTime}",
                                accountId = financing.accountId, toAccountId = null, fromAccountId = null,
                                amountCents = totalCentsForThisMonth,
                                type = "EXPENSE", dateEpochDay = txEpochDay,
                                categoryId = financing.categoryId ?: "",
                                description = financing.name + descSuffix,
                                merchantKey = "${financing.name ?: "Rata"} [fin:${financing.id}]",
                                subcategoryText = "Rata debito",
                                logoEmoji = financing.logoEmoji, logoUri = financing.logoUri,
                                isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = uniqueTime, updatedAtEpochMs = uniqueTime
                            ))
                        }

                        onSave(financing, listToSave)
                        showOldFinancingPrompt = false
                    }) { Text("SÌ, REGISTRA", color = brandPrimary, fontWeight = FontWeight.Bold) }
                },
                dismissButton = {
                    TextButton(onClick = {
                        val count = arrearsCountText.toIntOrNull() ?: 1
                        val financing = pendingFinancing!!
                        val start = LocalDate.fromEpochDays(financing.startEpochDay.toInt())

                        val listToSave = mutableListOf<TransactionEntity>()
                        val baseTime = Clock.System.now().toEpochMilliseconds()
                        val preferredDay = financing.smartDueDay

                        for (i in 0 until count) {
                            val txDate = addMonths(start, i, preferredDay)
                            val txEpochDay = txDate.toEpochDays().toLong()
                            val uniqueTime = baseTime + (i * 1000L)

                            var descSuffix = ""
                            if ((financing.extraInstallmentCents ?: 0L) > 0L && financing.extraInstallmentMonth?.toInt() == txDate.monthNumber) {
                                descSuffix = " + Rata Extra"
                            }

                            listToSave.add(TransactionEntity(
                                id = "tx_fin_zero_${i}_${uniqueTime}",
                                accountId = financing.accountId,
                                toAccountId = null, fromAccountId = null,
                                amountCents = 0L,
                                type = "EXPENSE", dateEpochDay = txEpochDay,
                                categoryId = financing.categoryId ?: "default",
                                description = financing.name + descSuffix,
                                merchantKey = "${financing.name ?: "Rata"} [fin:${financing.id}]",
                                subcategoryText = "Storico Precedente",
                                logoEmoji = financing.logoEmoji, logoUri = financing.logoUri,
                                isHidden = true,
                                isDeleted = false, reminderDays = null, createdAtEpochMs = uniqueTime, updatedAtEpochMs = uniqueTime
                            ))
                        }

                        onSave(financing.copy(createdAtEpochMs = Clock.System.now().toEpochMilliseconds()), listToSave)
                        showOldFinancingPrompt = false
                    }) { Text("NO, SALVA SOLO DEBITO", color = Color(0xFFA0A0A0)) }
                }
            )
        }
    }
}

@Composable
fun ActionIcon(icon: androidx.compose.ui.graphics.vector.ImageVector, label: String, color: androidx.compose.ui.graphics.Color, onClick: () -> Unit) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.clickable(indication = null, interactionSource = remember { MutableInteractionSource() }) { onClick() }
    ) {
        Surface(shape = RoundedCornerShape(50), color = color.copy(alpha = 0.1f), modifier = Modifier.size(48.dp)) {
            Icon(icon, contentDescription = label, tint = color, modifier = Modifier.padding(12.dp))
        }
        Spacer(Modifier.height(6.dp))
        Text(label, style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.SemiBold), color = color)
    }
}